import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";
import { COMPANY, scrollToId } from "../constants";

export const Footer = () => {
  const goSection = (id) => (e) => {
    e.preventDefault();
    if (window.location.pathname !== "/") {
      window.location.href = `/#${id}`;
    } else {
      scrollToId(id);
    }
  };

  return (
    <footer className="relative bg-navy-900 text-white/70 overflow-hidden" data-testid="footer">
      <div className="noise-overlay" />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <span className="inline-block bg-white rounded-xl px-4 py-2.5">
            <img src="/assets/emt-logo.png" alt="EMT-Reinigung Logo" className="h-9 w-auto" loading="lazy" width="542" height="218" />
          </span>
          <p className="mt-5 text-sm leading-relaxed max-w-xs">
            Professionelle Gebäudereinigung für Unternehmen in Lehrte &amp; Umgebung.
          </p>
        </div>
        <div>
          <h3 className="font-heading text-white text-base font-semibold mb-4">Kontakt</h3>
          <p className="text-sm leading-relaxed">
            {COMPANY.name}
            <br />
            {COMPANY.street}
            <br />
            {COMPANY.city}
          </p>
          <p className="mt-4 space-y-2 text-sm">
            <a href={COMPANY.phoneHref} className="flex items-center gap-2 hover:text-white transition-colors" data-testid="footer-phone-link">
              <Phone className="w-4 h-4 text-ice" /> {COMPANY.phoneDisplay}
            </a>
            <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-white transition-colors break-all" data-testid="footer-email-link">
              <Mail className="w-4 h-4 text-ice" /> {COMPANY.email}
            </a>
          </p>
        </div>
        <div>
          <h3 className="font-heading text-white text-base font-semibold mb-4">Links</h3>
          <nav className="flex flex-col gap-2.5 text-sm" aria-label="Footer Navigation">
            <a href="/#leistungen" onClick={goSection("leistungen")} className="hover:text-white transition-colors" data-testid="footer-link-leistungen">
              Leistungen
            </a>
            <a href="/#kontakt" onClick={goSection("kontakt")} className="hover:text-white transition-colors" data-testid="footer-link-kontakt">
              Kontakt
            </a>
            <Link to="/impressum" className="hover:text-white transition-colors" data-testid="footer-link-impressum">
              Impressum
            </Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors" data-testid="footer-link-datenschutz">
              Datenschutz
            </Link>
            <button
              onClick={() => window.dispatchEvent(new Event("emt:open-consent"))}
              className="text-left hover:text-white transition-colors"
              data-testid="footer-link-cookie-settings"
            >
              Cookie-Einstellungen
            </button>
          </nav>
        </div>
      </div>
      <div className="relative border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row justify-between gap-2 text-xs text-white/50">
          <span data-testid="footer-copyright">© 2026 EMT-Reinigung · Inhaber: Resit Tokul</span>
          <span>Bahnhofstraße 19 · 31275 Lehrte</span>
        </div>
      </div>
    </footer>
  );
};
